import { useAuth } from './AuthProvider.js';
const CONVENTION_ID = 'F9A';
const ATTENDEE = `SYSTEM_REG_${CONVENTION_ID}_ATTENDEE`;
const FIRST_CLASS = `SYSTEM_REG_${CONVENTION_ID}_FIRST_CLASS`;
const SPONSOR = `SYSTEM_REG_${CONVENTION_ID}_SPONSOR`;
const STAFF = `SYSTEM_REG_${CONVENTION_ID}_TEAM`;
const ULTRA = `SYSTEM_REG_${CONVENTION_ID}_ULTRA`;
const Tier = {
    Attendee: 'attendee',
    FirstClass: 'firstClass',
    Sponsor: 'sponsor',
    Ultra: 'ultra',
    Staff: 'staff',
};
export const isRegistered = (auth) => {
    if (auth.state !== 'loggedIn' || auth.user.system_roles == null) {
        return {
            registered: false,
            tier: undefined,
        };
    }
    // TODO: mapping
    if (auth.user.system_roles.some((role) => role.role_name === ULTRA)) {
        return {
            registered: true,
            tier: Tier.Ultra,
        };
    }
    if (auth.user.system_roles.some((role) => role.role_name === STAFF)) {
        return {
            registered: true,
            tier: Tier.Staff,
        };
    }
    if (auth.user.system_roles.some((role) => role.role_name === SPONSOR)) {
        return {
            registered: true,
            tier: Tier.Sponsor,
        };
    }
    if (auth.user.system_roles.some((role) => role.role_name === FIRST_CLASS)) {
        return {
            registered: true,
            tier: Tier.FirstClass,
        };
    }
    if (auth.user.system_roles.some((role) => role.role_name === ATTENDEE)) {
        return {
            registered: true,
            tier: Tier.Attendee,
        };
    }
    return {
        registered: false,
        tier: undefined,
    };
};
const useIsRegistered = () => isRegistered(useAuth());
export default useIsRegistered;
//# sourceMappingURL=useIsRegistered.js.map